<template>
  <v-app-bar dense v-if="breakpointName === 'xs'" fixed color="#FFFFFF">
    <v-spacer />
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="scroll-y-transition">
      <template #activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </template>
      <v-card>
        <div>
          <v-row class="mt-2">
            <v-col align="end" class="px-6">
              <v-btn class="ml-2" @click="dialog = false" icon>
                <v-icon size="45">mdi-window-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-card>
                <v-list-group
                  v-for="(item, index) in items"
                  :key="`item-key-${index}`"
                  :value="true"
                  no-action
                  color="#212121"
                >
                  <template #activator>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-bold">{{ item.name }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <v-divider></v-divider>
                  <div v-for="(subItem, index) in item.subItems" :key="`sub-item-${index}`">
                    <v-divider></v-divider>
                    <v-list-item :to="subItem.path" @click="dialog = false">
                      <v-list-item-content>
                        <v-list-item-title>{{ subItem.name }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                  </div>
                </v-list-group>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
  </v-app-bar>
</template>

<script>
export default {
  name: 'MobileHeader',
  data() {
    return {
      dialog: false
    }
  },
  computed: {
    items() {
      let items = [
        {
          name: this.$t('message.usages'),
          subItems: [
            { name: this.$t('message.invoice'), path: '/invoice' },
          ]
        }
      ]
      if (this.licenseeType == "LICENSEE") {
        items.unshift({
          name: 'KitchenBASE Wiki',
          subItems: [
            { name: this.$t('message.notice'), path: '/wiki/f9b97452727c40e1a1a2fad4606a25fb' },
            { name: this.$t('message.manual'), path: '/wiki/dacee4ec78b2462781cf29ed71066b18' },
            { name: this.$t('message.guide'), path: '/wiki/5a9e7291cce44f90a35879391e2647c5' }
          ]
        },)
      }
      return items
    },
    breakpointName() {
      return this.$vuetify.breakpoint.name
    }
  }
}
</script>
